import React, { FC, memo } from 'react';
import { Icon } from 'udesk-ui';

interface TemplateProps {
    type?: string | number;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { type } = props;

    return (
        <>
            {type === 1 || type === '1' ? (
                <Icon antdIcon type="PhoneOutlined"></Icon>
            ) : type === 2 || type === '2' ? (
                <Icon antdIcon type="MessageOutlined"></Icon>
            ) : type === 3 || type === '3' ? (
                <Icon antdIcon type="ProfileOutlined"></Icon>
            ) : type === 4 || type === '4' ? (
                <Icon antdIcon type="VideoCameraOutlined"></Icon>
            ) : type === 8 || type === '8' ? (
                <Icon antdIcon type="FormOutlined"></Icon>
            ) : (
                '-'
            )}
        </>
    );
});

export default Template;
